import * as React from "react";
import { isIErrorResponse } from "@warda/library-ui/contexts/utils";
import FormSharePageLogin from "@warda/library-ui/layout/FormSharePageLogin";
import { ERROR_GENERIC } from "@warda/library-ui/constants";
import { getPageCode, setAccessCodeTokenForPageCode } from "./accessCodeUtil/";
import { doSharePageLogin } from "../../api/fetchesApiSharePage";
const FormLogin = ({ onLoginSuccess }) => {
    const handleRequest = React.useCallback(async (password) => {
        const pageCode = getPageCode();
        try {
            const cookiesInfo = await doSharePageLogin({ pageCode, password });
            setAccessCodeTokenForPageCode({ pageCode, ...cookiesInfo });
            onLoginSuccess();
            return { success: true, message: null };
        }
        catch (err) {
            if (isIErrorResponse(err)) {
                if ((err.status = 401))
                    return { success: false, message: "Password is invalid!" };
                return { success: false, message: err.error };
            }
            return { success: false, message: ERROR_GENERIC };
        }
    }, [onLoginSuccess]);
    return React.createElement(FormSharePageLogin, { onRequest: handleRequest });
};
export default FormLogin;
